const wowApp = require('angular').module('oly.common');
const { breadCrumbsComponentDefinition } = require('./breadcrumbs.component');

wowApp.component('wowBreadcrumbs', breadCrumbsComponentDefinition);



// WEBPACK FOOTER //
// ./src/olycommon/breadcrumbs/index.js